import React from "react";
import SequenceRead from "../../sequence/SequenceRead";
import { STRUCTURE } from "./config";

// The Structure Read: the shared motion Read flow with Structure's examples
// and copy (config.js).
export default function StructureRead() {
  return <SequenceRead read={STRUCTURE} />;
}
